'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formId = undefined;
var _jsxFileName = 'src/new-business/quick-quote/form.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _formNavigation = require('@marmalade/form/lib/components/form-navigation');
var _formNavigation2 = _interopRequireDefault(_formNavigation);
var _postcode = require('@marmalade/form/lib/questions/postcode');
var _postcode2 = _interopRequireDefault(_postcode);
var _vehicleLookup = require('@marmalade/form/lib/components/vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
var _actions = require('@marmalade/ldi/lib/quote/actions');
var _selectors = require('./selectors');
var _guid = require('../../guid');
var _guid2 = _interopRequireDefault(_guid);
var _age = require('./age');
var _age2 = _interopRequireDefault(_age);
var _quickQuote = require('../../validation/quick-quote');
var _quickQuote2 = _interopRequireDefault(_quickQuote);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = exports.formId = 'quickQuote';
var QuickQuoteForm = function (_Component) {
  _inherits(QuickQuoteForm, _Component);
  function QuickQuoteForm() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, QuickQuoteForm);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickQuoteForm.__proto__ || Object.getPrototypeOf(QuickQuoteForm)).call.apply(_ref, [this].concat(args))), _this), _this.tryAgain = function () {
      window.location.reload();
    }, _this.submitArguments = function () {
      if (!_this.props.fdiQuickQuote) {
        return _this.props.guid;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(QuickQuoteForm, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.props.handleQuickQuoteSubmit(this.props.guid, 'NEW', this.props.fdiQuickQuote),
        product: 'ldi',
        validator: (0, _quickQuote2.default)(this.props.fdiQuickQuote),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        },
        __self: this
      }, this.props.fdiQuickQuote && _react2.default.createElement(_vehicleLookup2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        },
        __self: this
      }), !this.props.fdiQuickQuote || this.props.abiCode ? _react2.default.createElement(_react2.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        },
        __self: this
      }, _react2.default.createElement(_postcode2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        },
        __self: this
      }), _react2.default.createElement(_age2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        },
        __self: this
      }), _react2.default.createElement(_formNavigation2.default, {
        next: {
          submit: true,
          text: 'Get a quote',
          icon: false
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        },
        __self: this
      })) : null);
    }
  }]);
  return QuickQuoteForm;
}(_react.Component);
QuickQuoteForm.propTypes = {
  // DTP
  handleQuickQuoteSubmit: _propTypes.func.isRequired,
  fetchFDIQuickQuote: _propTypes.func,
  guid: _propTypes.string,
  fdiQuickQuote: _propTypes.bool,
  abiCode: _propTypes.string
};
QuickQuoteForm.defaultProps = {
  guid: undefined
};
exports.default = (0, _glamorous.withTheme)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    guid: (0, _guid2.default)(state, ownProps.theme),
    abiCode: (0, _selectors.abiCode)(state)
  };
}, {
  handleQuickQuoteSubmit: _actions.handleQuickQuoteSubmit,
  fetchFDIQuickQuote: _actions.fetchFDIQuickQuote
})(QuickQuoteForm));